import { gql } from '@apollo/client';

/**
 * ТЗ 0103, этап 4 — фрагменты SEO (DataForSEO). Как и у остального
 * раздела, фрагменты не вложены друг в друга: запрос подключает каждый сам.
 *
 * Возможность (`MarketingSeoOpportunity`) нормализуется по `id`: решение
 * «В план» (`setMarketingSeoOpportunityStatus`) возвращает строки целиком, и
 * статус обновляется во всех списках, где она видна (идеи недели, карточка
 * запроса, «Что написать»).
 */
export const MARKETING_SEO_OPPORTUNITY_FIELDS = gql`
  fragment MarketingSeoOpportunityFields on MarketingSeoOpportunity {
    id
    kind
    status
    familySlug
    familyName
    keywordId
    keyword
    url
    params
    evidence
    score
    valuePlnEst
    isCurrent
    firstSeen
    lastSeen
    decidedBy
    decidedAt
    note
    link
  }
`;

/**
 * Строка запроса недели: своя позиция с изменением, ряд за 8 недель, лучший
 * конкурент, клики и показы GSC за 28 дней. Зависит от недели снимка и
 * недели сравнения — в кеше без нормализации (`keyFields: false`).
 */
export const MARKETING_SEO_KEYWORD_ROW_FIELDS = gql`
  fragment MarketingSeoKeywordRowFields on MarketingSeoKeywordRow {
    id
    keyword
    familySlug
    isBrand
    brandOf
    intent
    searchVolume
    cpc
    difficulty
    tracked
    excluded
    trackReason
    source
    position
    prevPosition
    delta
    change
    comparable
    zone
    url
    spark
    bestCompetitor
    bestCompetitorPosition
    bestCompetitorSource
    serpOrganic
    domainPosition
    gscClicks28d
    gscImpressions28d
    gscPosition28d
    hasAiOverview
    aiOverviewCitesUs
  }
`;
